const DocStarIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.8056 17.1133L17.7147 15.1856C17.8314 14.9381 18.1686 14.9381 18.2853 15.1856L19.1944 17.1133L21.2275 17.4243C21.4884 17.4642 21.5923 17.7998 21.4035 17.9923L19.9326 19.4917L20.2797 21.61C20.3243 21.882 20.0515 22.0895 19.8181 21.961L18 20.9603L16.1819 21.961C15.9485 22.0895 15.6757 21.882 15.7203 21.61L16.0674 19.4917L14.5965 17.9923C14.4077 17.7998 14.5116 17.4642 14.7725 17.4243L16.8056 17.1133Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5 12V5.74853C20.5 5.5894 20.4368 5.43679 20.3243 5.32426L17.1757 2.17574C17.0632 2.06321 16.9106 2 16.7515 2H5.1C4.76863 2 4.5 2.26863 4.5 2.6V21.4C4.5 21.7314 4.76863 22 5.1 22H11.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M16.5 2V5.4C16.5 5.73137 16.7686 6 17.1 6H20.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export default DocStarIcon;
